import "core-js/modules/es.function.name.js";
import React from 'react';
import { useTranslation } from 'react-i18next';
import useFetchFormattedShareTemplate from 'hooks/useFetchFormattedShareTemplate';
import useUniqueId from 'hooks/useUniqueId';
import Card from 'components/Card';
import Modal from 'components/Modal';
import ModalHeadline from 'components/ModalHeadline';
import Landmark from 'components/Landmark';
import AdminShareEditor from '../AdminShareContentModal/ShareEditor';
import SimpleShareEditor from '../SimpleShareContentModal/ShareEditor';
import Panel from 'components/Panel';
import Alert from 'components/Alert';
function ShareEditor(_ref) {
  var emailTemplate = _ref.emailTemplate,
    shareType = _ref.shareType,
    data = _ref.data,
    onClose = _ref.onClose;
  if (shareType) {
    return /*#__PURE__*/React.createElement(AdminShareEditor, {
      shareType: shareType,
      data: data,
      defaultMessage: emailTemplate === null || emailTemplate === void 0 ? void 0 : emailTemplate.message,
      defaultSubject: emailTemplate === null || emailTemplate === void 0 ? void 0 : emailTemplate.subject,
      onClose: onClose
    });
  }
  return /*#__PURE__*/React.createElement(SimpleShareEditor, {
    data: data,
    defaultMessage: emailTemplate === null || emailTemplate === void 0 ? void 0 : emailTemplate.message,
    defaultSubject: emailTemplate === null || emailTemplate === void 0 ? void 0 : emailTemplate.subject,
    onClose: onClose
  });
}
function ModalWrapper(_ref2) {
  var _ref2$showEditor = _ref2.showEditor,
    showEditor = _ref2$showEditor === void 0 ? true : _ref2$showEditor,
    _ref2$canShowAlert = _ref2.canShowAlert,
    canShowAlert = _ref2$canShowAlert === void 0 ? false : _ref2$canShowAlert,
    data = _ref2.data,
    children = _ref2.children,
    subtitle = _ref2.subtitle,
    shareType = _ref2.shareType,
    onClose = _ref2.onClose;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var titleId = useUniqueId();
  var _useFetchFormattedSha = useFetchFormattedShareTemplate(),
    isShareEmailTemplateLoading = _useFetchFormattedSha.isLoading,
    shareTemplate = _useFetchFormattedSha.shareTemplate;
  var type = data.type,
    playlistIds = data.playlistIds,
    assetIds = data.assetIds,
    name = data.name,
    overallContentAudienceType = data.overallContentAudienceType;
  var count = type === 'playlist' ? playlistIds === null || playlistIds === void 0 ? void 0 : playlistIds.length : assetIds === null || assetIds === void 0 ? void 0 : assetIds.length;
  var title = name ? t('share_title', {
    name: name
  }) : t('actions_share', {
    context: type,
    count: count
  });
  var isAdminContent = overallContentAudienceType === 'admin';
  return /*#__PURE__*/React.createElement(Modal, {
    id: "share-modal-".concat(titleId),
    "aria-labelledby": titleId,
    onRequestClose: onClose,
    width: "wide"
  }, /*#__PURE__*/React.createElement(Card, {
    variant: "raised"
  }, /*#__PURE__*/React.createElement(ModalHeadline, {
    title: title,
    titleId: titleId,
    subtitle: subtitle,
    onClose: onClose
  }), canShowAlert && isAdminContent && /*#__PURE__*/React.createElement(Panel, {
    flush: "top"
  }, /*#__PURE__*/React.createElement(Alert, null, t('share_hint_admin_audience'))), children, showEditor && (isShareEmailTemplateLoading ? /*#__PURE__*/React.createElement(Landmark, {
    icon: "spinner",
    height: 220
  }) : /*#__PURE__*/React.createElement(ShareEditor, {
    shareType: shareType,
    data: data,
    emailTemplate: shareTemplate,
    onClose: onClose
  }))));
}
export default ModalWrapper;